<template>
    <zen-message-modal :isOpen="isOpen" title="Revoke permission?">
        Revoking this permission will remove the
        <strong>{{ grant?.role }}</strong> role at
        <strong>{{ scopeLabelText }}</strong> from this team. All team members
        will lose this access.
        <template v-slot:buttons>
            <zen-button
                variant="secondary"
                size="medium"
                @click="$emit('close')"
            >
                Cancel
            </zen-button>
            <zen-button
                variant="primary-danger"
                size="medium"
                :processing="processing"
                @click="$emit('confirm')"
            >
                Revoke
            </zen-button>
        </template>
    </zen-message-modal>
</template>

<script>
export default {
    name: 'RevokeTeamPermissionModal',
    props: {
        isOpen: {
            type: Boolean,
            required: true,
        },
        grant: {
            type: Object,
            default: null,
        },
        processing: {
            type: Boolean,
            default: false,
        },
        scopeLabelText: {
            type: String,
            default: '',
        },
    },
    emits: ['close', 'confirm'],
}
</script>
